import React, { useState } from "react";
import AddNewDoctor from "../addNewDoctor";
import { ModalType } from "../../../../shared/utils/enums";
import MainTable from "../../../../components/mainTable";
import { useDispatch } from "react-redux";
import { showModal } from "../../../../connected-components/modal/reducer";
import { sampleDoctorData } from "../../../../shared/static/data/doctors";
import { getDoctorsTableColumns } from "../../../../shared/tableColumns/doctorsColumns";

const DoctorsList = () => {
  const dispatch = useDispatch();
  const [doctors, setDoctors] = useState(sampleDoctorData);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const handleRowPress = (doctor: any) => {
    console.log("Doctor selected:", doctor);
  };

  const handleCheckedChange = ({
    row,
    value,
  }: {
    row: any;
    value: boolean;
  }) => {
    setDoctors((prev: any) =>
      prev.map((doc: any) =>
        doc.id === row.id ? { ...doc, emergencyPrivileges: value } : doc,
      ),
    );
  };

  const handlePageChange = ({
    pageIndex,
    pageSize: newPageSize,
  }: {
    pageIndex: number;
    pageSize: number;
  }) => {
    setCurrentPage(pageIndex);
    setPageSize(newPageSize);
  };

  const handleAddNewDoctor = () => {
    dispatch(
      showModal({
        type: ModalType.COMPONENT,
        title: "Add New Doctor",
        component: <AddNewDoctor />,
        onClose: () => {
          // Here you would typically refresh the doctors list from your API
          // For now, we'll just use the sample data
          setDoctors(sampleDoctorData);
        },
      }),
    );
  };

  const handleEditDoctor = (doctor: any) => {
    console.log("Edit doctor:", doctor);
    // Handle edit action
  };

  const handleDeleteDoctor = (doctor: any) => {
    console.log("Delete doctor:", doctor);
    // Handle delete action
  };

  const columns = getDoctorsTableColumns({
    onEdit: handleEditDoctor,
    onDelete: handleDeleteDoctor,
  });

  return (
    <div className="py-4">
      <MainTable
        data={doctors}
        columns={columns}
        onRowPress={handleRowPress}
        onCheckedChange={handleCheckedChange}
        showPagination={true}
        totalData={doctors.length}
        pageSize={pageSize}
        currentPage={currentPage}
        onPageChanged={handlePageChange}
        isLoading={false}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        showSearch={true}
        addButtonLabel="Add New Doctor"
        onAddNewItemPress={handleAddNewDoctor}
      />
    </div>
  );
};

export default DoctorsList;
